import React from 'react';

import SvgContainer from '../SvgContainer';

const CalendarFewWorkouts = () => {
    return (
        <SvgContainer>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.63158 7.78223C7.63158 7.22994 7.18386 6.78223 6.63158 6.78223H4.94737C4.39508 6.78223 3.94737 7.22994 3.94737 7.78223V9.55013C3.94737 10.1024 4.39508 10.5501 4.94737 10.5501H6.63158C7.18386 10.5501 7.63158 10.1024 7.63158 9.55013V7.78223Z"
            />
            <path d="M10.5789 14.6948L9.19447 13.2789C8.95087 13.0298 8.54443 13.049 8.32542 13.32C8.13986 13.5496 8.15557 13.8818 8.36198 14.0929L9.47368 15.2299L10.0558 15.8252C10.2837 16.0583 10.6532 16.0583 10.8811 15.8252L11.4632 15.2299L14.6708 11.6692C14.8559 11.4637 14.8495 11.1498 14.6561 10.952C14.4437 10.7348 14.0916 10.7431 13.8897 10.9702L10.5789 14.6948Z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0526 1.50716H12.7895C13.6 1.50716 14.2632 2.18538 14.2632 3.01432V9.01211C14.2632 9.27344 14.1609 9.52438 13.9782 9.71123L13.647 10.0499C13.3337 10.3704 12.7895 10.1485 12.7895 9.70038V5.77507C12.7895 5.49892 12.5656 5.27507 12.2895 5.27507H2.97368C2.69754 5.27507 2.47368 5.49892 2.47368 5.77507V13.0645C2.47368 13.3406 2.69754 13.5645 2.97368 13.5645H6.01958C6.33812 13.5645 6.63761 13.7162 6.82598 13.9731L7.04807 14.2759C7.29027 14.6062 7.05442 15.0716 6.64487 15.0716H2.47368C1.65579 15.0716 1 14.3934 1 13.5645L1.00737 3.01432C1.00737 2.18538 1.65579 1.50716 2.47368 1.50716H3.21053V0.736842C3.21053 0.329895 3.54042 0 3.94737 0C4.35432 0 4.68421 0.329896 4.68421 0.736842V1.50716H10.5789V0.736843C10.5789 0.329896 10.9088 0 11.3158 0C11.7227 0 12.0526 0.329896 12.0526 0.736843V1.50716Z"
            />
        </SvgContainer>
    );
};

export default CalendarFewWorkouts;
